module.exports = __webpack_public_path__ + "assets/img/donate-edit-bg.5963f136.png";